// extracted by mini-css-extract-plugin
export var footer = "_rk-0";
export var inherit = "_rk-1";
export var input = "_rk-2";
export var modalContent = "_rk-3";
export var quillEditor = "_rk-4";
export var subtitle = "_rk-5";